// Module
var code = "<template> <require from=\"app/core/components/automations/automations-grid\"></require> <automations-grid if.bind=\"actionsLoaded\" module-code.bind=\"moduleCode\" record-types.bind=\"recordTypes\" options.bind=\"options\" actions.bind=\"actions\" automations-saved.delegate=\"loadConditionOptions()\"></automations-grid> </template> ";
// Exports
module.exports = code;